<script>
import UserTile from '../../UserTile.vue';

export default {
  name: 'AdminLisUserCell',
  components: { UserTile },
  props: {
    row: Object,
  },
  computed: {
    isAdmin() {
      return (this.row.roles.includes('ROLE_ADMIN') || this.row.roles.includes('ROLE_OBSERVER') || this.row.roles.includes('ROLE_ALLOWED_TO_SWITCH'));
    },
  },
  methods: {
    goToProfile() {
      this.$router.push({ name: 'admin-user-detail', params: { userId: this.row.id, tab: 'common' } });
    },
  },
};
</script>

<template lang="pug">
  .user-container
    Icon.icon(name="setting" :class="{ admin: isAdmin }")
    UserTile(:user="row" :isLink="true" @nameClick="goToProfile") {{ row.email }}
</template>

<style scoped lang="scss">
.user-container {
  position: relative;
}
.icon {
  position: absolute;
  top: -4px;
  left: -4px;
  z-index: 2;
  display: none;
  fill: rgba(51, 161, 251, 1);
}

.admin {
  display: block;
}
</style>
